// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KSLh","content":"styles_content__58pkz"};